export const API_PATH =  "https://mccannet.mccann.com.mx/wp-json/wp/v2/";
